// extracted by mini-css-extract-plugin
export default {"checkbox":"YB1a68LKTCpDTdkKzonJ3Q=="};